import { render, staticRenderFns } from "./SettingsGroups.vue?vue&type=template&id=3043d3f2"
import script from "./SettingsGroups.vue?vue&type=script&lang=js"
export * from "./SettingsGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports